<template>
  <pt-policy-manage class="pt-policy-manage__page"></pt-policy-manage>
</template>

<script>
import PtPolicyManage from 'cps/other-service/pt-policy-manage/withData'
export default {
  name: 'pt-policy-manage__view',
  components: {
    'pt-policy-manage': PtPolicyManage
  }
}
</script>
